<template>
    <div>
        <accordion-item :keep-closed="true" :content-pull="true">

            <h2 slot="header">
                General Damages
            </h2>
            <div class="m-div-table__holder">
                <benefit store-key="gdPneumoconiosis"
                         title="General Damages"
                         subtitle="Pneumoconiosis etc, (Workers Compensation) Act 1979 including any extra statutory payments made following the rejection of a claim under the 1979 Act"
                         show-header
                ></benefit>
                <benefit title="General Damages"
                         store-key="gdMesothelioma"
                         subtitle="2008 Diffuse Mesothelioma Scheme"
                         is-last
                         show-header
                ></benefit>
            </div>
        </accordion-item>
    </div>
</template>

<script>
    import AccordionItem from 'components/accordion/AccordionItem';
    import Benefit from "./Benefit";

    export default {
        components: {
            Benefit,
            AccordionItem
        }
    }
</script>


// WEBPACK FOOTER //
// GeneralDamages.vue?a3b6b424